import ShippingMethodRadioGroup from './ShippingMethodRadioGroup';
import CheckoutBox from '../../../components/core/CheckoutBox/CheckoutBox';

const ShippingMethod = () => {
    return (
        <CheckoutBox header={'Shipping Method'}>
            <ShippingMethodRadioGroup />
        </CheckoutBox>
    );
};

export default ShippingMethod;
